

import moment from 'moment';

import { defineComponent } from 'vue';


export default defineComponent({
  name: "TimelineItem",
  props: {
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: Object,
      required: true,
      component: String,
      color: String,
    },
    title: {
      type: String,
      required: true,
    },
    dateTime: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    pedido: {
      type: Array,
      default: () => {},
    },
  },
  computed: {
    getPedido(): any {
      if(!this.pedido)return {};
      return this.pedido
    }
  },
  methods: {
    toHora(date:any) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
  }
});
